/**
 * A random id this browser keeps, so an organization's free video previews
 * (docs/Decisions.md D65 item 1) are counted per visitor without an account.
 * It identifies nobody: it is not tied to a person, sent nowhere else, and a
 * cleared browser simply starts again (the API also holds previews per IP).
 */
const KEY = 'cap.visitorId';
let memoryId = null;

function randomId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}

export function getVisitorId(storage = globalThis.localStorage) {
  try {
    const saved = storage?.getItem(KEY);
    if (saved && /^[A-Za-z0-9-]{16,64}$/.test(saved)) return saved;
    const id = randomId();
    storage?.setItem(KEY, id);
    return id;
  } catch {
    // Storage blocked (private window): one id for this page's lifetime.
    memoryId = memoryId || randomId();
    return memoryId;
  }
}
